// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"45c77358","977":"d5ba5ebd"}[chunkId] + ".chunk.js";
};